import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText.js';
// ##### Komarov 2025-07-19
import { setCounterAdults, setCounterChild, setCounterRooms } from '../../../../Redux/actions/paxchoice.js';

// ##### 23-09-14 Komarov
// import './HotelsPaxChoiceCSS.css'
// import 'antd/dist/antd.css';
// ##### Komarov 2025-07-18
const HotelsPaxChoiceGridPageDevices = ({ rowGap }) => {

  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);

  // ##### Komarov 2025-08-05
  const Adults = useLocalizedText('Adults');
  const Children = useLocalizedText('Children');
  const Rooms = useLocalizedText('Rooms');
  const twelve_plus_years = useLocalizedText('twelve_plus_years');
  const two_eleven_years = useLocalizedText('two_eleven_years');

  // ##### Komarov 2025-07-18
  const dispatch = useDispatch();

  const addAdult = () => {
    dispatch(setCounterAdults(counterAdults + 1));
  };

  const deductAdult = () => {
    counterAdults > 1
      ? dispatch(setCounterAdults(counterAdults - 1))
      : dispatch(setCounterAdults(1));
  };

  const addChild = () => {
    // counterChild<2? setCounterChild(counterChild+1) : alert('This tour allows upto 2 Children')
    dispatch(setCounterChild(counterChild + 1));
  };

  const deductChild = () => {
    counterChild > 0 ? dispatch(setCounterChild(counterChild - 1)) : dispatch(setCounterChild(0));
  };

  const addRooms = () => {
    // counterInfant<1? setCounterInfant(counterInfant+1) : alert('This tour allows upto 1 Infant')
    dispatch(setCounterRooms(counterRooms + 1));
  };

  const deductRooms = () => {
    counterRooms > 1 ? dispatch(setCounterRooms(counterRooms - 1)) : dispatch(setCounterRooms(1));
  };

  // ##### 23-11-08 Komarov
  return (
    <div
      data-component="HotelsPaxChoiceGridPageDevices"
      // className={className}
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(3, 6vh)',
        //  ##### 22-11-14 Komarov
        rowGap,
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {
            // ##### 23-10-04 Komarov
            Adults}
        </h4>
        <MinusOutlined
          style={{ color: 'white' }}
          className="MinusInner"
          onClick={deductAdult} />
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {counterAdults}
        </h4>
        <PlusOutlined
          className="PlusInner"
          style={{ color: 'white' }}
          onClick={addAdult} />
        {/* ##### 23-07-06 Komarov */}
        {/* <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>12+ years</h4> */}
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {
            // ##### 23-10-04 Komarov
            twelve_plus_years}
        </h4>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {
            // ##### 23-10-04 Komarov
            Children}
        </h4>
        <MinusOutlined
          className="MinusInner"
          style={{ color: 'white' }}
          onClick={deductChild} />
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {counterChild}
        </h4>
        <PlusOutlined
          className="PlusInner"
          style={{ color: 'white' }}
          onClick={addChild} />
        {/* ##### 23-07-06 Komarov */}
        {/* <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>2-11 years</h4> */}
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {
            // ##### 23-10-04 Komarov
            two_eleven_years}
        </h4>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '25% 17% 16% 17% 25%',
        }}
      >
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {
            // ##### 23-10-04 Komarov
            Rooms}
        </h4>
        <MinusOutlined
          className="MinusInner"
          style={{ color: 'white' }}
          onClick={deductRooms} />
        <h4 style={{ fontSize: '14px', fontFamily: 'Arial' }}>
          {counterRooms}
        </h4>
        <PlusOutlined
          className="PlusInner"
          style={{ color: 'white' }}
          onClick={addRooms} />
      </div>
    </div>
  );
};
// ##### 25-05-21 Komarov
export default HotelsPaxChoiceGridPageDevices;
